import { Message } from 'element-ui'
import { MessageBox } from 'element-ui'
import { Notification } from 'element-ui'

export function successNot(msg) {
  Notification({
    title: '提示',
    message: msg,
    type: 'success'
  })
}
export function errorNot(msg) {
  Notification({
    title: '提示',
    message: msg,
    type: 'error'
  })
}
export function infoMsg(msg) {
  Message({
    showClose: true,
    message: msg
  })
}

export function successMsg(msg) {
  Message({
    showClose: true,
    message: msg,
    type: 'success'
  })
}

export function warnMsg(msg) {
  Message({
    showClose: true,
    message: msg,
    type: 'warning'
  })
}

export function errorMsg(msg) {
  Message({
    showClose: true,
    message: msg,
    type: 'error'
  })
}

export function openBox(msg, op, cb) {
  MessageBox.confirm(msg, '提示', {
    confirmButtonText: op.confirm ? op.confirm : '确定',
    cancelButtonText: op.cancel ? op.cancel : '取消',
    confirmButtonClass: op.className,
    type: op.type
  }).then(() => {
    if (typeof cb === 'function') {
      cb()
    }
  }).catch(() => {
    if (typeof op.quit === 'function') {
      op.quit()
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/message.js